import { useRouter } from 'next/router';
import React, { ReactNode, useRef } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';
import DrawerHeader from './DrawerHeader';

const spring = {
  type: 'spring',
  damping: 10,
  stiffness: 100
};

interface MFiltersDrawerProps {
  isOpen: boolean;
  handleCloseDrawer: () => void;
  snapPoints: number[];
  children: ReactNode;
  headerTitle?: string;
  handleResetFilter?: () => void;
}

const MFiltersDrawer = ({
  isOpen,
  snapPoints,
  handleCloseDrawer,
  headerTitle,
  handleResetFilter,
  children
}: MFiltersDrawerProps) => {
  const { locale } = useRouter();

  const sheetRef = useRef<SheetRef>();

  const handleClickOutside = (e: MouseEvent | TouchEvent | PointerEvent) => {
    handleCloseDrawer();
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  };

  return (
    <Sheet
      ref={sheetRef}
      isOpen={isOpen}
      onClose={handleCloseDrawer}
      snapPoints={snapPoints}
      initialSnap={0}
      animate
      transition={spring}
      prefersReducedMotion
    >
      <Sheet.Container
        style={{
          padding: '8px 16px 24px 16px'
        }}
      >
        <Sheet.Header
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '16px'
          }}
        >
          <Sheet.Header />

          <DrawerHeader
            title={headerTitle}
            handleResetFilter={handleResetFilter}
          />
        </Sheet.Header>

        <Sheet.Content
          style={{
            width: '100%',
            position: 'relative',
            display: 'flex',
            justifyContent: 'space-between',
            direction: locale === 'ar' ? 'rtl' : 'ltr'
          }}
          disableDrag
        >
          <Sheet.Scroller className="hide-scrollbar">{children}</Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>

      <Sheet.Backdrop onTap={handleClickOutside} />
    </Sheet>
  );
};

export default MFiltersDrawer;
